import { Suspense } from "react";
import { Box, CircularProgress } from "@mui/material";
import Header from "./Header";
import Sidebar from "./Sidebar";
import CreateProject from "./CreateProject";
import RaiseRequestDialog from "./RaiseRequestDialog";
import { useApp } from "../context/AppContext";

const Layout = ({ children }) => {
  const {
    codifierOpen,
    setCodifierOpen,
    approverOpen,
    setApproverOpen,
    reporterOpen,
    setReporterOpen,
    applicatorOpen,
    setApplicatorOpen,
    sidebarOpen,
    setSidebarOpen,
    currentProject,
    isExecUser,
    projects,
    isLoading,
    user,
    raiseRequestOpen,
    setRaiseRequestOpen,
  } = useApp();

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Show loading state while projects are being fetched
  if (isLoading) {
    return (
      <Box
        sx={{
          height: "100vh",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            transform: "scale(0.8)",
            transformOrigin: "top left",
            width: "125%",
            height: "125vh",
          }}
        >
          <Header currentProject={currentProject} />
          <Box sx={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center" }}>
            <CircularProgress />
          </Box>
        </Box>
      </Box>
    );
  }

  // If there are no projects, show CreateProject flow (skip for suppliers)
  if ((!projects || projects.length === 0) && user?.role !== "cbSupplier") {
    return (
      <Box
        sx={{
          height: "100vh",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            transform: "scale(0.8)",
            transformOrigin: "top left",
            width: "125%",
            height: "125vh",
          }}
        >
          <Header currentProject={currentProject} />
          <Box
            sx={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", p: 3 }}
          >
            <CreateProject isFirstProject={true} />
          </Box>
        </Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        height: "100vh",
        overflow: "hidden", // Prevent scrolling on the outer container
        position: "relative",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100vh",
        }}
      >
        <Header currentProject={currentProject} />
        <Box sx={{ display: "flex", flex: 1, overflow: "hidden" }}>
          {!isExecUser && (
            <Sidebar
              isOpen={sidebarOpen}
              onToggle={handleSidebarToggle}
              codifierOpen={codifierOpen}
              setCodifierOpen={setCodifierOpen}
              approverOpen={approverOpen}
              setApproverOpen={setApproverOpen}
              reporterOpen={reporterOpen}
              setReporterOpen={setReporterOpen}
              applicatorOpen={applicatorOpen}
              setApplicatorOpen={setApplicatorOpen}
            />
          )}
          <Box
            sx={{
              flex: 1,
              overflow: "auto",
              p: 3,
              bgcolor: "surface.subtle",
            }}
          >
            {/* a page loading inside the layout keeps the header and sidebar on screen */}
            <Suspense
              fallback={
                <Box sx={{ display: "flex", justifyContent: "center", p: 6 }}>
                  <CircularProgress size={28} />
                </Box>
              }
            >
              {children}
            </Suspense>
          </Box>
        </Box>
      </Box>
      <RaiseRequestDialog open={raiseRequestOpen} onClose={() => setRaiseRequestOpen(false)} />
    </Box>
  );
};

export default Layout;
